import {
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

// PCS.Web's OAuth token endpoint has no refresh-token grant configured (no
// RefreshTokenProvider in Startup.Auth.cs), so there's nothing to refresh here -
// an expired access token just results in a 401, handled by authInterceptor.
export const authRefreshInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    return next(req);
};
